<template>
  <v-dialog
    v-model="dialog"
    class="forgot-password__dialog"
    width="500"
  >
    <template v-slot:activator="{ props }"> </template>

    <v-card class="pa-5" v-model="isClose">
      <v-row>
        <v-col cols="3">
          <v-btn icon variant="text" @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="9">
          <v-card-title
            class="d-flex justify-start align-center text-center mb-3"
            >Forgot Password</v-card-title
          >
        </v-col>
      </v-row>

      <form @submit.prevent="submit" class="login-form">
        <v-text-field
          v-model="input.value.value"
          :error-messages="input.errorMessage.value"
          variant="outlined"
          label="Mobile Number"
        ></v-text-field>
        <div>
          <v-btn
            class="bg-theme-primary mt-3"
            type="submit"
            size="large"
            width="100%"
          >
            Request OTP
          </v-btn>
          <v-card-text
            class="d-flex align-center text-center justify-center py-1"
          >
            Already a user?
            <span class="blue" @click="() => handleRedirect('Login')"
              >&nbsp;Login
            </span>
          </v-card-text>
          <v-card-text class="d-flex align-center text-center justify-center" v-if="marketplaceContent !== 'private'">
            Don't have an account?
            <span class="blue" @click="() => handleRedirect('SignUp')"
              >&nbsp;Sign Up
            </span>
          </v-card-text>
        </div>

        <div class="d-flex align-center text-center justify-center mt-3 mb-3">
          <v-btn @click="dialog = false" elevation="0"> close </v-btn>
        </div>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
  import app from './index.js';

  export default app;
</script>